/**
 * URL 상태가 PROD인지, DEV인지, LOCAL인지 확인하는 함수
 */
export const checkUrlStatus = () => {
  const url = window.location.href;
  if (url.includes("bio-research.ai")) return "PROD";
  if (url.includes("bio-research.dev")) return "DEV";
  return "LOCAL";
};
